export default __webpack_public_path__ + "static/media/05.223c64d2.jpg";